import { render } from "./Stores.vue?vue&type=template&id=0a546337&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"

import "./Stores.vue?vue&type=style&index=0&id=0a546337&scoped=true&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a546337"]])

export default __exports__